export default "__VITE_ASSET__DfSaQ_R0__"